import React from 'react';

const Skeleton = () => (
  <div className="my-6 space-y-3">
    <div className="flex items-center justify-between px-4">
      <div className="h-4 w-32 rounded bg-gray-200" />
      <div className="flex items-center gap-2">
        <div className="w-45 h-4 rounded bg-gray-200" />
        <div className="w-45 h-4 rounded bg-gray-200" />
      </div>
    </div>
    {Array.from({ length: 5 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className="flex animate-pulse items-center justify-between rounded-lg bg-white p-3.5">
        <div className="flex items-center gap-3">
          <div className="h-6 w-6 rounded-full bg-gray-200" />
          <div className="h-4 w-32 rounded bg-gray-200" />
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <div className="w-30 h-4 rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
);

export default Skeleton;
